<template>
    <div class="bg-image-wrap pb-40 pb-lg-60">
        <div class="image-bg w-100">
            <v-container class="container--large">
                <div :class="className + ' w-100 bg-grey-light'"></div>
            </v-container>
        </div>
        <div class="bg-image-content">
            <v-container>
                <v-row class="align-md-center align-lg-start">
                    <v-col cols="12" md="5" lg="6" class="mb-12 mb-md-0">
                        <v-img :src="src" max-width="535" class="mx-auto mx-md-0"></v-img>
                    </v-col>
                    <v-col cols="12" md="7" lg="6">
                        <div class="pt-lg-24 pt-xl-54">
                            <slot/>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        className : {type :String, default : ""},
        src : {type :String, default : ""},
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	// mounted() {
	// 	this.init();
	// },
	// methods : {
	// 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
	// 	}
	// },
}
</script>

<style scoped>
.bg-image-wrap{
    position: relative;
}
.image-bg{
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
}
.bg-image-content{
    position: relative;
    z-index: 1;
}
</style>